// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__24ybJ","header":"ClearentDisclaimer_header__4WmNU","inner":"ClearentDisclaimer_inner__2bYWt"};